export default "__VITE_ASSET__BBooXX67__"